import { useEffect, useRef, useState } from 'react';

export const InteractiveStreetViewPanorama = ({
  position,
  onLoad,
}: {
  position: google.maps.LatLngLiteral;
  onLoad?: () => void;
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [streetview, setStreetview] = useState<
    google.maps.StreetViewPanorama | undefined
  >();

  useEffect(() => {
    if (ref.current && streetview === undefined) {
      console.log('initializing new streetview object');
      const _streetview = new window.google.maps.StreetViewPanorama(
        ref.current,
        {
          position,
          fullscreenControl: false,
          showRoadLabels: false,
          addressControl: false,
          imageDateControl: false,
          zoomControl: false,
          panControl: false,
          linksControl: true,
          motionTrackingControl: false,
          motionTracking: false,
          disableDefaultUI: true,
        }
      );

      _streetview.addListener('status_changed', () => {
        if (_streetview.getStatus() === 'OK') {
          onLoad?.();
        }
      });

      setStreetview(_streetview);

      return () => {
        console.log('cleaning up streetview object');
        setStreetview(undefined);
      };
    }
  }, [ref]);

  useEffect(() => {
    if (streetview) {
      streetview.setPosition(position);
    }
  }, [streetview, JSON.stringify(position)]);

  return <div ref={ref} id='map' className='h-full w-full' />;
};
